module.exports = __webpack_public_path__ + "static/media/SurfaceOceanCurrentsWorld.48080f0b.gif";